import type { UserViewContext } from '../../WebappChatUI/hooks/useUserViewContext/types';
import type { MergeUserViewContextParams } from '../types';

const mergeUserViewContext = ({
    baseContext,
    contribution,
}: MergeUserViewContextParams): UserViewContext => {
    if (contribution === null) {
        return baseContext;
    }

    return {
        ...baseContext,
        ids: {
            ...contribution.ids,
            ...baseContext.ids,
        },
        description: `${baseContext.description}. ${contribution.descriptionSuffix}`,
        hints: [...baseContext.hints, ...contribution.hints],
    };
};

export default mergeUserViewContext;
